import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class AlunoService {

  constructor(private db: AngularFireDatabase) {
  }

  get() {
    return this.db.list('alunos').valueChanges();
  }

  getSnapshot() {
    return this.db.database.ref('alunos').once('value');
  }

  insert(aluno, id) {
    return this.db.database.ref(`alunos/${id}`).set(aluno);
  }

}
